import { Component, OnInit, SimpleChanges, Input, EventEmitter, Output, ElementRef, ViewChild, NgZone } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatCheckbox, MatDialog } from '@angular/material';
import { Observable } from 'rxjs';
import { SignaturePadComponent } from 'src/app/commons/signature-pad/signature-pad.component';
import { UtilityService } from 'src/app/services/utility.service';
import { UserDocumentService } from '../../services/user-document.service';
import { NewFileModalComponent } from 'src/app/files/new-file-modal/new-file-modal.component';
import * as _ from 'lodash';
import { Router } from '@angular/router';
import { MapsService } from 'src/app/services/maps.service';
import { AssetService } from 'src/app/services/asset.service';
@Component({
  selector: 'app-incident-investigation-report',
  templateUrl: './incident-investigation-report.component.html',
  styleUrls: ['./incident-investigation-report.component.scss']
})
export class IncidentInvestigationReportComponent implements OnInit {


  @Input('accident') accidentData
  @Input('user') userData
  @Input('documentData') documentDetails
  @Output() openFilesSideNav: EventEmitter<any> = new EventEmitter();
  @ViewChild('search', { static: false })
  public searchElementRef: ElementRef;
  previousIndex: any;
  currentUser
  minTime
  infoForm1: FormGroup
  infoForm2: FormGroup
  stepperForm1: FormGroup
  stepperForm2: FormGroup
  stepperForm3: FormGroup
  stepperForm5: FormGroup
  stepperForm6: FormGroup
  stepperForm7: FormGroup
  stepperForm8: FormGroup
  stepperForm9: FormGroup
  stepperForm10: FormGroup
  stepperForm11: FormGroup
  stepperForm12: FormGroup
  stepperForm13: FormGroup
  stepperForm14: FormGroup
  sign1: boolean;
  sign2: boolean;
  date1
  date2
  date3
  date4
  date5
  date6
  date7
  date8
  date9
  date10
  date
  date11
  date12
  choosenTime1
  choosenTime2
  choosenTime3
  choosenTime4
  choosenTime5
  choosenTime6
  choosenTime7
  choosenTime8
  choosenTime9
  choosenTime10
  choosenTime11
  loading: boolean;
  accidentId: any;
  userId: any;
  accidentDetails: any;
  userDetails: any;
  isEdit: boolean;
  accidentLocation: any;
  dateOfIncident: any;
  userName: any;
  extraDetails: any;
  files: any = [];
  newFiles: any = [];
  isAdmin: boolean;
  user: any;
  latitude: number;
  longitude: number;
  zoom: number;
  isMapEdit
  address: string;
  constructor(
    public dialog: MatDialog,
    public router: Router,
    private _mapsService: MapsService,
    private formBuilder: FormBuilder,
    public _utilityService: UtilityService,
    public _assetService: AssetService,
    public userDocumentService: UserDocumentService,
    private ngZone: NgZone
  ) {
  }

  ngOnInit() {
    this.loading = true;
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'))
    this.user = JSON.parse(localStorage.getItem('userRoles'));
    console.log("this.user", this.user);
    if (this.user.isAdmin) {
      console.log("this.isAdmin", this.user.isAdmin);
      this.isAdmin = true
    }
    if (this.isEdit) { }
    else {
      // this.setCurrentLocation();
    }

    this.createInfoForm1()
    this.createInfoForm2()
    this.createstepperForm1()
    this.createstepperForm2()
    this.createstepperForm3()
    this.createstepperForm5()
    this.createstepperForm6()
    this.createstepperForm7()
    this.createstepperForm8()
    this.createstepperForm9()
    this.createstepperForm10()
    this.createstepperForm11()
    this.createstepperForm12()
    this.createstepperForm13()
    this.createstepperForm14()

  }





  ngOnChanges(changes: SimpleChanges): void {
    console.log("CHANGES in child component", changes);
    if (changes.accidentData && changes.accidentData.currentValue) {
      this.accidentId = changes.accidentData.currentValue
    }

    if (changes.userData && changes.userData.currentValue) {
      this.userId = changes.userData.currentValue
    }
    if (changes.documentDetails && changes.documentDetails.currentValue) {
      let data = changes.documentDetails.currentValue
      this.accidentDetails = data.accidentDetails
      this.userDetails = data.userData
      this.loading = false
      if (data && data.details && data.details && data.details.details.infoForm1) {
        let displayData = data.details.details
        // this.formDetails = data.details.details.reportingForm1
        // this.form2Details = data.details.details.reportingForm2
        // this.form3Details = data.details.details.reportingForm3
        // this.form4Details = data.details.details.reportingForm4
        this.files = data.details.files
        this.extraDetails = data.details
        // this.chosenTime = this.formDetails.time
        // this.date = this.formDetails.date
        this.isEdit = true
        this.isMapEdit = true
        if (displayData.stepperForm14 && displayData.stepperForm14.sign1 != "") {
          this.sign1 = true
        }
        if (displayData.stepperForm14 && displayData.stepperForm14.sign2 != "") {
          this.sign2 = true
        }

        let locationData = data.details.details.stepperForm2


        this.latitude = (locationData && locationData.location) ? locationData.location.coords.lat : ''
        console.log("here is the latitude", this.latitude)
        this.longitude = (locationData && locationData.location) ? locationData.location.coords.lng : ''
        this.address = (locationData && locationData.location) ? locationData.location.address : ''


        // this.latitude = data.details.details.stepperForm2.location.coords.lat
        // console.log("here is the latitude", this.latitude)
        // this.longitude = data.details.details.stepperForm2.location.coords.lng
        // this.address = data.details.details.stepperForm2.location.address
        this.stepperForm2.value['location'] = {
          coords: { lat: this.latitude, lng: this.longitude },
          address: this.address
        }
        // this.createForm1(this.formDetails)
        // this.createForm2(this.form2Details)
        // this.createForm3(this.form3Details)
        // this.createForm4(this.form4Details)


        this.createInfoForm1(displayData.infoForm1)
        this.createInfoForm2(displayData.infoForm2)
        this.createstepperForm1(displayData.stepperForm1)
        this.createstepperForm2(displayData.stepperForm2)
        this.createstepperForm3(displayData.stepperForm3)
        this.createstepperForm5(displayData.stepperForm5)
        this.createstepperForm6(displayData.stepperForm6)
        this.createstepperForm7(displayData.stepperForm7)
        this.createstepperForm8(displayData.stepperForm8)
        this.createstepperForm9(displayData.stepperForm9)
        this.createstepperForm10(displayData.stepperForm10)
        this.createstepperForm11(displayData.stepperForm11)
        this.createstepperForm12(displayData.stepperForm12)
        this.createstepperForm13(displayData.stepperForm13)
        this.createstepperForm14(displayData.stepperForm14)
      } else {



        this.isEdit = false
        // this.userName = this.userDetails && this.userDetails._id ? this.userDetails._id.user.name : this.userDetails.user.name
        this.accidentLocation = this.accidentDetails.location && this.accidentDetails.location.address ? this.accidentDetails.location.address : ''
        this.dateOfIncident = this.accidentDetails.date
        if (this.userDetails && this.userDetails._id && this.userDetails._id.user) {
          console.log("this user details", this.userDetails);

          this.userName = this.userDetails._id.user.name
        } else {
          this.userName = this.userDetails.user.name
        }
        this.isMapEdit = false
        this.createstepperForm2()
        // this.createForm1()
        // this.createForm2()
        console.log("call this else part", this.userName, this.accidentLocation);
      }
    }


  }












  // FORM GROUP

  createInfoForm1(infoForm?) {
    this.infoForm1 = this.formBuilder.group({
      toAddress: new FormControl((infoForm && infoForm.toAddress) ? infoForm.toAddress : ''),
      fromAddress: new FormControl((infoForm && infoForm.fromAddress) ? infoForm.fromAddress : ''),
      contactNo: new FormControl((infoForm && infoForm.contactNo) ? infoForm.contactNo : ''),
      date1: new FormControl((infoForm && infoForm.date1) ? infoForm.date1 : '')
    })
  }

  createInfoForm2(infoForm?) {
    this.infoForm2 = this.formBuilder.group({
      staffAcc: new FormControl((infoForm && infoForm.staffAcc) ? infoForm.staffAcc : ''),
      illHealth: new FormControl((infoForm && infoForm.illHealth) ? infoForm.illHealth : ''),
      publicAcc: new FormControl((infoForm && infoForm.publicAcc) ? infoForm.publicAcc : ''),
      contractorEmp: new FormControl((infoForm && infoForm.contractorEmp) ? infoForm.contractorEmp : ''),
      states: new FormControl((infoForm && infoForm.states) ? infoForm.states : '')
    })
  }

  createstepperForm1(stepperObj?) {
    this.stepperForm1 = this.formBuilder.group({
      surname: new FormControl((stepperObj && stepperObj.surname) ? stepperObj.surname : ''),
      forename: new FormControl((stepperObj && stepperObj.forename) ? stepperObj.forename : '')
    })
  }

  createstepperForm2(stepperObj?) {
    this.stepperForm2 = this.formBuilder.group({
      date2: new FormControl((stepperObj && stepperObj.date2) ? stepperObj.date2 : this.dateOfIncident),
      timePick1: new FormControl((stepperObj && stepperObj.timePick1) ? stepperObj.timePick1 : ''),
      // location: new FormControl((stepperObj && stepperObj.location) ? stepperObj.location : this.accidentLocation),
      firstAidGiven: new FormControl((stepperObj && stepperObj.firstAidGiven) ? stepperObj.firstAidGiven : ''),
      yesDetails: new FormControl((stepperObj && stepperObj.yesDetails) ? stepperObj.yesDetails : ''),
      personFirstAid: new FormControl((stepperObj && stepperObj.personFirstAid) ? stepperObj.personFirstAid : ''),
      stateName: new FormControl((stepperObj && stepperObj.stateName) ? stepperObj.stateName : ''),
      selectOption: new FormControl((stepperObj && stepperObj.selectOption) ? stepperObj.selectOption : ''),
      personInHospital: new FormControl((stepperObj && stepperObj.personInHospital) ? stepperObj.personInHospital : '')
    })
  }

  createstepperForm3(stepperObj?) {
    this.stepperForm3 = this.formBuilder.group({
      description: new FormControl((stepperObj && stepperObj.description) ? stepperObj.description : ''),
      risk: new FormControl((stepperObj && stepperObj.risk) ? stepperObj.risk : ''),
    })
  }

  createstepperForm5(stepperObj?) {
    this.stepperForm5 = this.formBuilder.group({
      absentDays: new FormControl((stepperObj && stepperObj.absentDays) ? stepperObj.absentDays : ''),
      affectPart: new FormControl((stepperObj && stepperObj.affectPart) ? stepperObj.affectPart : ''),
      affectedPart: new FormControl((stepperObj && stepperObj.affectedPart) ? stepperObj.affectedPart : ''),
      checkbox1: new FormControl((stepperObj && stepperObj.checkbox1) ? stepperObj.checkbox1 : false),
      checkbox2: new FormControl((stepperObj && stepperObj.checkbox2) ? stepperObj.checkbox2 : false),
      checkbox3: new FormControl((stepperObj && stepperObj.checkbox3) ? stepperObj.checkbox3 : false),
      checkbox4: new FormControl((stepperObj && stepperObj.checkbox4) ? stepperObj.checkbox4 : false),
      checkbox5: new FormControl((stepperObj && stepperObj.checkbox5) ? stepperObj.checkbox5 : false),
      checkbox6: new FormControl((stepperObj && stepperObj.checkbox6) ? stepperObj.checkbox6 : false),
      timePick2: new FormControl((stepperObj && stepperObj.timePick2) ? stepperObj.timePick2 : ''),
      timePick3: new FormControl((stepperObj && stepperObj.timePick3) ? stepperObj.timePick3 : '')
    })
  }

  createstepperForm6(stepperObj?) {
    this.stepperForm6 = this.formBuilder.group({
      injuryDegree: new FormControl((stepperObj && stepperObj.injuryDegree) ? stepperObj.injuryDegree : ''),
      bodyAfected: new FormControl((stepperObj && stepperObj.bodyAfected) ? stepperObj.bodyAfected : ''),
      sideWhich: new FormControl((stepperObj && stepperObj.sideWhich) ? stepperObj.sideWhich : ''),
      injuryNature: new FormControl((stepperObj && stepperObj.injuryNature) ? stepperObj.injuryNature : ''),
      locations: new FormControl((stepperObj && stepperObj.locations) ? stepperObj.locations : ''),
      groundFloor: new FormControl((stepperObj && stepperObj.groundFloor) ? stepperObj.groundFloor : ''),
      weather: new FormControl((stepperObj && stepperObj.weather) ? stepperObj.weather : ''),
      lighting: new FormControl((stepperObj && stepperObj.lighting) ? stepperObj.lighting : ''),
      inspected: new FormControl((stepperObj && stepperObj.inspected) ? stepperObj.inspected : ''),
      specifyForLighting: new FormControl((stepperObj && stepperObj.specifyForLighting) ? stepperObj.specifyForLighting : ''),
      specifyForNature: new FormControl((stepperObj && stepperObj.specifyForNature) ? stepperObj.specifyForNature : ''),
      specifyForWeather: new FormControl((stepperObj && stepperObj.specifyForWeather) ? stepperObj.specifyForWeather : ''),
      specifyForGround: new FormControl((stepperObj && stepperObj.specifyForGround) ? stepperObj.specifyForGround : ''),
      specifyForLocation: new FormControl((stepperObj && stepperObj.specifyForLocation) ? stepperObj.specifyForLocation : ''),

    })

    console.log('lighting control data ', this.stepperForm6.value.specifyForLighting)
  }


  createstepperForm7(stepperObj?) {
    this.stepperForm7 = this.formBuilder.group({
      sex: new FormControl((stepperObj && stepperObj.sex) ? stepperObj.sex : ''),
      grade: new FormControl((stepperObj && stepperObj.grade) ? stepperObj.grade : ''),
      date3: new FormControl((stepperObj && stepperObj.date3) ? stepperObj.date3 : ''),
      insNo: new FormControl((stepperObj && stepperObj.insNo) ? stepperObj.insNo : ''),
      date4: new FormControl((stepperObj && stepperObj.date4) ? stepperObj.date4 : ''),
      date5: new FormControl((stepperObj && stepperObj.date5) ? stepperObj.date5 : ''),
      homeDepot: new FormControl((stepperObj && stepperObj.homeDepot) ? stepperObj.homeDepot : ''),
      titleOrName: new FormControl((stepperObj && stepperObj.titleOrName) ? stepperObj.titleOrName : ''),
      medicalLimitation: new FormControl((stepperObj && stepperObj.medicalLimitation) ? stepperObj.medicalLimitation : ''),
      giveDetail: new FormControl((stepperObj && stepperObj.giveDetail) ? stepperObj.giveDetail : ''),
    })
  }

  createstepperForm8(stepperObj?) {
    this.stepperForm8 = this.formBuilder.group({
      absentDay: new FormControl((stepperObj && stepperObj.absentDay) ? stepperObj.absentDay : ''),
      leaveType: new FormControl((stepperObj && stepperObj.leaveType) ? stepperObj.leaveType : ''),
      date6: new FormControl((stepperObj && stepperObj.date6) ? stepperObj.date6 : ''),
      date7: new FormControl((stepperObj && stepperObj.date7) ? stepperObj.date7 : ''),
      actualDays: new FormControl((stepperObj && stepperObj.actualDays) ? stepperObj.actualDays : ''),
      timePick4: new FormControl((stepperObj && stepperObj.timePick4) ? stepperObj.timePick4 : ''),
      timePick5: new FormControl((stepperObj && stepperObj.timePick5) ? stepperObj.timePick5 : ''),
      date8: new FormControl((stepperObj && stepperObj.date8) ? stepperObj.date8 : ''),
      timePick6: new FormControl((stepperObj && stepperObj.timePick6) ? stepperObj.timePick6 : ''),
      timePick7: new FormControl((stepperObj && stepperObj.timePick7) ? stepperObj.timePick7 : ''),
      timePick8: new FormControl((stepperObj && stepperObj.timePick8) ? stepperObj.timePick8 : ''),
      timePick9: new FormControl((stepperObj && stepperObj.timePick9) ? stepperObj.timePick9 : ''),
    })
  }

  createstepperForm9(stepperObj?) {
    this.stepperForm9 = this.formBuilder.group({
      optionSelect1: new FormControl((stepperObj && stepperObj.optionSelect1) ? stepperObj.optionSelect1 : ''),
      yesDetails1: new FormControl((stepperObj && stepperObj.yesDetails1) ? stepperObj.yesDetails1 : ''),
      optionSelect2: new FormControl((stepperObj && stepperObj.optionSelect2) ? stepperObj.optionSelect2 : ''),
      yesDetails2: new FormControl((stepperObj && stepperObj.yesDetails2) ? stepperObj.yesDetails2 : ''),
      ppeItem: new FormControl((stepperObj && stepperObj.ppeItem) ? stepperObj.ppeItem : ''),
      optionSelect3: new FormControl((stepperObj && stepperObj.optionSelect3) ? stepperObj.optionSelect3 : ''),
      yesDetails3: new FormControl((stepperObj && stepperObj.yesDetails3) ? stepperObj.yesDetails3 : ''),
      optionSelect4: new FormControl((stepperObj && stepperObj.optionSelect4) ? stepperObj.optionSelect4 : ''),
      yesDetails4: new FormControl((stepperObj && stepperObj.yesDetails4) ? stepperObj.yesDetails4 : ''),
      optionSelect5: new FormControl((stepperObj && stepperObj.optionSelect5) ? stepperObj.optionSelect5 : ''),
      yesDetails5: new FormControl((stepperObj && stepperObj.yesDetails5) ? stepperObj.yesDetails5 : ''),
      optionSelect6: new FormControl((stepperObj && stepperObj.optionSelect6) ? stepperObj.optionSelect6 : ''),
      yesDetails6: new FormControl((stepperObj && stepperObj.yesDetails6) ? stepperObj.yesDetails6 : ''),
      optionSelect7: new FormControl((stepperObj && stepperObj.optionSelect7) ? stepperObj.optionSelect7 : ''),
      yesDetails7: new FormControl((stepperObj && stepperObj.yesDetails7) ? stepperObj.yesDetails7 : ''),
      optionSelect8: new FormControl((stepperObj && stepperObj.optionSelect8) ? stepperObj.optionSelect8 : ''),
      optionSelect9: new FormControl((stepperObj && stepperObj.optionSelect9) ? stepperObj.optionSelect9 : ''),
      optionSelect10: new FormControl((stepperObj && stepperObj.optionSelect10) ? stepperObj.optionSelect10 : ''),
      option10Observed: new FormControl((stepperObj && stepperObj.option10Observed) ? stepperObj.option10Observed : ''),
      option10Broken: new FormControl((stepperObj && stepperObj.option10Broken) ? stepperObj.option10Broken : ''),
      option10Wrongly: new FormControl((stepperObj && stepperObj.option10Wrongly) ? stepperObj.option10Wrongly : ''),
      procedure: new FormControl((stepperObj && stepperObj.procedure) ? stepperObj.procedure : ''),
      optionSelect11: new FormControl((stepperObj && stepperObj.optionSelect11) ? stepperObj.optionSelect11 : ''),
      explain: new FormControl((stepperObj && stepperObj.explain) ? stepperObj.explain : ''),
      optionSelect12: new FormControl((stepperObj && stepperObj.optionSelect12) ? stepperObj.optionSelect12 : ''),
      yesDetails12: new FormControl((stepperObj && stepperObj.yesDetails12) ? stepperObj.yesDetails12 : ''),
      optionSelect13: new FormControl((stepperObj && stepperObj.optionSelect13) ? stepperObj.optionSelect13 : ''),
      optionSelect: new FormControl((stepperObj && stepperObj.optionSelect) ? stepperObj.optionSelect : ''),
      optionSelect14: new FormControl((stepperObj && stepperObj.optionSelect14) ? stepperObj.optionSelect14 : ''),
      optionSelect15: new FormControl((stepperObj && stepperObj.optionSelect15) ? stepperObj.optionSelect15 : ''),
      optionSelect16: new FormControl((stepperObj && stepperObj.optionSelect16) ? stepperObj.optionSelect16 : ''),
      optionSelect17: new FormControl((stepperObj && stepperObj.optionSelect17) ? stepperObj.optionSelect17 : ''),
      optionSelect18: new FormControl((stepperObj && stepperObj.optionSelect18) ? stepperObj.optionSelect18 : ''),
      supervisionDegree: new FormControl((stepperObj && stepperObj.supervisionDegree) ? stepperObj.supervisionDegree : ''),
      specifyForPpeItem: new FormControl((stepperObj && stepperObj.specifyForPpeItem) ? stepperObj.specifyForPpeItem : ''),
    })
  }

  createstepperForm10(stepperObj?) {
    this.stepperForm10 = this.formBuilder.group({
      vehicleInvolve: new FormControl((stepperObj && stepperObj.vehicleInvolve) ? stepperObj.vehicleInvolve : ''),
      vehicleType1: new FormControl((stepperObj && stepperObj.vehicleType1) ? stepperObj.vehicleType1 : ''),
      vehicleType2: new FormControl((stepperObj && stepperObj.vehicleType2) ? stepperObj.vehicleType2 : ''),
      vehicleType3: new FormControl((stepperObj && stepperObj.vehicleType3) ? stepperObj.vehicleType3 : ''),
      vehicleNo: new FormControl((stepperObj && stepperObj.vehicleNo) ? stepperObj.vehicleNo : ''),
      specifyForVehicle: new FormControl((stepperObj && stepperObj.specifyForVehicle) ? stepperObj.specifyForVehicle : '')
    })
  }

  createstepperForm11(stepperObj?) {
    this.stepperForm11 = this.formBuilder.group({

      toolInvolve: new FormControl((stepperObj && stepperObj.toolInvolve) ? stepperObj.toolInvolve : ''),
      whatWasIt: new FormControl((stepperObj && stepperObj.whatWasIt) ? stepperObj.whatWasIt : ''),
      itInUse: new FormControl((stepperObj && stepperObj.itInUse) ? stepperObj.itInUse : ''),
      taskCorrect: new FormControl((stepperObj && stepperObj.taskCorrect) ? stepperObj.taskCorrect : ''),
      specifyForWhatWasIt: new FormControl((stepperObj && stepperObj.specifyForWhatWasIt) ? stepperObj.specifyForWhatWasIt : ''),
    })
  }

  createstepperForm12(stepperObj?) {
    this.stepperForm12 = this.formBuilder.group({
      date9: new FormControl((stepperObj && stepperObj.date9) ? stepperObj.date9 : ''),
      whoBy: new FormControl((stepperObj && stepperObj.whoBy) ? stepperObj.whoBy : ''),
      illNature: new FormControl((stepperObj && stepperObj.illNature) ? stepperObj.illNature : ''),
      date10: new FormControl((stepperObj && stepperObj.date10) ? stepperObj.date10 : ''),
      circumstance: new FormControl((stepperObj && stepperObj.circumstance) ? stepperObj.circumstance : '')
    })
  }

  createstepperForm13(stepperObj?) {
    this.stepperForm13 = this.formBuilder.group({
      selectOption1: new FormControl((stepperObj && stepperObj.selectOption1) ? stepperObj.selectOption1 : ''),
      selectOption2: new FormControl((stepperObj && stepperObj.selectOption2) ? stepperObj.selectOption2 : ''),
      occurWhere: new FormControl((stepperObj && stepperObj.occurWhere) ? stepperObj.occurWhere : ''),
      selectOption3: new FormControl((stepperObj && stepperObj.selectOption3) ? stepperObj.selectOption3 : ''),
      date: new FormControl((stepperObj && stepperObj.date) ? stepperObj.date : ''),
      selectOption4: new FormControl((stepperObj && stepperObj.selectOption4) ? stepperObj.selectOption4 : ''),
      date11: new FormControl((stepperObj && stepperObj.date11) ? stepperObj.date11 : ''),
      timePick10: new FormControl((stepperObj && stepperObj.timePick10) ? stepperObj.timePick10 : ''),
      timePick11: new FormControl((stepperObj && stepperObj.timePick11) ? stepperObj.timePick11 : ''),
      descriptions: new FormControl((stepperObj && stepperObj.descriptions) ? stepperObj.descriptions : '')
    })
  }

  createstepperForm14(stepperObj?) {
    this.stepperForm14 = this.formBuilder.group({
      H01: new FormControl((stepperObj && stepperObj.H01) ? stepperObj.H01 : false),
      H02: new FormControl((stepperObj && stepperObj.H02) ? stepperObj.H02 : false),
      H03: new FormControl((stepperObj && stepperObj.H03) ? stepperObj.H03 : false),
      H04: new FormControl((stepperObj && stepperObj.H04) ? stepperObj.H04 : false),
      H05: new FormControl((stepperObj && stepperObj.H05) ? stepperObj.H05 : false),
      H06: new FormControl((stepperObj && stepperObj.H06) ? stepperObj.H06 : false),
      H07: new FormControl((stepperObj && stepperObj.H07) ? stepperObj.H07 : false),
      H08: new FormControl((stepperObj && stepperObj.H08) ? stepperObj.H08 : false),
      H09: new FormControl((stepperObj && stepperObj.H09) ? stepperObj.H09 : false),
      H10: new FormControl((stepperObj && stepperObj.H10) ? stepperObj.H10 : false),
      H11: new FormControl((stepperObj && stepperObj.H11) ? stepperObj.H11 : false),
      H12: new FormControl((stepperObj && stepperObj.H12) ? stepperObj.H12 : false),
      H13: new FormControl((stepperObj && stepperObj.H13) ? stepperObj.H13 : false),
      H14: new FormControl((stepperObj && stepperObj.H14) ? stepperObj.H14 : false),
      H15: new FormControl((stepperObj && stepperObj.H15) ? stepperObj.H15 : false),
      H16: new FormControl((stepperObj && stepperObj.H16) ? stepperObj.H16 : false),
      H17: new FormControl((stepperObj && stepperObj.H17) ? stepperObj.H17 : false),
      T01: new FormControl((stepperObj && stepperObj.T01) ? stepperObj.T01 : false),
      T02: new FormControl((stepperObj && stepperObj.T02) ? stepperObj.T02 : false),
      T03: new FormControl((stepperObj && stepperObj.T03) ? stepperObj.T03 : false),
      T04: new FormControl((stepperObj && stepperObj.T04) ? stepperObj.T04 : false),
      T05: new FormControl((stepperObj && stepperObj.T05) ? stepperObj.T05 : false),
      T06: new FormControl((stepperObj && stepperObj.T06) ? stepperObj.T06 : false),
      MC1: new FormControl((stepperObj && stepperObj.MC1) ? stepperObj.MC1 : false),
      MC2: new FormControl((stepperObj && stepperObj.MC2) ? stepperObj.MC2 : false),
      MC3: new FormControl((stepperObj && stepperObj.MC3) ? stepperObj.MC3 : false),
      MC4: new FormControl((stepperObj && stepperObj.MC4) ? stepperObj.MC4 : false),
      MC5: new FormControl((stepperObj && stepperObj.MC5) ? stepperObj.MC5 : false),
      MC6: new FormControl((stepperObj && stepperObj.MC6) ? stepperObj.MC6 : false),
      MC7: new FormControl((stepperObj && stepperObj.MC7) ? stepperObj.MC7 : false),
      MC8: new FormControl((stepperObj && stepperObj.MC8) ? stepperObj.MC8 : false),
      MC9: new FormControl((stepperObj && stepperObj.MC9) ? stepperObj.MC9 : false),
      MC10: new FormControl((stepperObj && stepperObj.MC10) ? stepperObj.MC10 : false),
      MC11: new FormControl((stepperObj && stepperObj.MC11) ? stepperObj.MC11 : false),
      MC12: new FormControl((stepperObj && stepperObj.MC12) ? stepperObj.MC12 : false),
      MC13: new FormControl((stepperObj && stepperObj.MC13) ? stepperObj.MC13 : false),
      MC14: new FormControl((stepperObj && stepperObj.MC14) ? stepperObj.MC14 : false),
      M01: new FormControl((stepperObj && stepperObj.M01) ? stepperObj.M01 : false),
      M02: new FormControl((stepperObj && stepperObj.M02) ? stepperObj.M02 : false),
      M03: new FormControl((stepperObj && stepperObj.M03) ? stepperObj.M03 : false),
      M04: new FormControl((stepperObj && stepperObj.M04) ? stepperObj.M04 : false),
      M05: new FormControl((stepperObj && stepperObj.M05) ? stepperObj.M05 : false),
      M06: new FormControl((stepperObj && stepperObj.M06) ? stepperObj.M06 : false),
      humanErr: new FormControl((stepperObj && stepperObj.humanErr) ? stepperObj.humanErr : ''),
      technical: new FormControl((stepperObj && stepperObj.technical) ? stepperObj.technical : ''),
      management: new FormControl((stepperObj && stepperObj.management) ? stepperObj.management : ''),
      miscellaneous: new FormControl((stepperObj && stepperObj.miscellaneous) ? stepperObj.miscellaneous : ''),
      mainCause: new FormControl((stepperObj && stepperObj.mainCause) ? stepperObj.mainCause : ''),
      decideAction: new FormControl((stepperObj && stepperObj.decideAction) ? stepperObj.decideAction : ''),
      madeChange: new FormControl((stepperObj && stepperObj.madeChange) ? stepperObj.madeChange : ''),
      madeChangeAssessment: new FormControl((stepperObj && stepperObj.madeChangeAssessment) ? stepperObj.madeChangeAssessment : ''),
      madeChangeSafety: new FormControl((stepperObj && stepperObj.madeChangeSafety) ? stepperObj.madeChangeSafety : ''),
      madeChangePolicy: new FormControl((stepperObj && stepperObj.madeChangePolicy) ? stepperObj.madeChangePolicy : ''),
      changeResult: new FormControl((stepperObj && stepperObj.changeResult) ? stepperObj.changeResult : ''),
      docName: new FormControl((stepperObj && stepperObj.docName) ? stepperObj.docName : ''),
      docNo: new FormControl((stepperObj && stepperObj.docNo) ? stepperObj.docNo : ''),
      clientDetails: this.formBuilder.array(this.clientDetailsWithContact((stepperObj && stepperObj.clientDetails) ? stepperObj.clientDetails : [])),
      // client: new FormControl((stepperObj && stepperObj.client) ? stepperObj.client : ''),
      // contact: new FormControl((stepperObj && stepperObj.contact) ? stepperObj.contact : ''),
      designation: new FormControl((stepperObj && stepperObj.designation) ? stepperObj.designation : ''),
      sendToDirector: new FormControl((stepperObj && stepperObj.sendToDirector) ? stepperObj.sendToDirector : ''),
      date12: new FormControl((stepperObj && stepperObj.date12) ? stepperObj.date12 : ''),
      sign1: new FormControl((stepperObj && stepperObj.sign1) ? stepperObj.sign1 : ''),
      sign2: new FormControl((stepperObj && stepperObj.sign2) ? stepperObj.sign2 : '')
    })
  }

  // UTILITY


  setCurrentLocation(mapCurrentValue) {
    console.log("hello common map component Return Value...", mapCurrentValue)
    this.latitude = mapCurrentValue.latitude
    this.longitude = mapCurrentValue.longitude
    this.address = mapCurrentValue.address
  }

  //   private setCurrentLocation() {
  //     // this._mapsService.setCurrentLocation().subscribe((data) => {
  //     //   console.log("data------->", data);
  //     //   this.latitude = data.latitude;
  //     //   this.longitude = data.longitude;
  //     // })
  //     this._mapsService.setCurrentLocation().subscribe((data) => {
  //       this.latitude = data.latitude;
  //       this.longitude = data.longitude;
  //       this.address = data.address
  //       let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement);

  //       autocomplete.addListener("place_changed", () => {

  //         this.ngZone.run(() => {

  //           let place: google.maps.places.PlaceResult = autocomplete.getPlace();


  //           if (place.geometry === undefined || place.geometry === null) {
  //             return;
  //           }
  //           console.log("not returned ------------------")
  //           console.log('PLACE------------->', place)
  //           this.latitude = place.geometry.location.lat();
  //           console.log("this.latitude",this.latitude)
  //           this.longitude = place.geometry.location.lng();
  //           console.log("this.longitude", this.longitude)
  //           this.address = place.formatted_address
  //           this.zoom = 12;

  //         });

  //       });
  //   })
  // }
  //   markerDragEnd(event) {
  //     console.log('mark drag event check', event);
  //     this._mapsService.markerDragEnd(event).subscribe((data) => {
  //       console.log("data------->", data);
  //       this.latitude = data.latitude;
  //       this.longitude = data.longitude;
  //       this.address = data.address;
  //     });
  //   }

  fileDetails(event) {
    console.log("event ====", event);
    this.previousIndex = event.index
    this.openFilesSideNav.emit({ event })
  }

  onChangeEvent(value, formGroup, formControl) {
    console.log(formControl, formGroup);

    if (formGroup == 'infoForm1')
      this.infoForm1.get(formControl).setValue(value);
    // this.infoForm1.patchValue({ date1: value })

    else if (formGroup == 'stepperForm2')
      this.stepperForm2.get(formControl).setValue(value);

    else if (formGroup == 'stepperForm7')
      this.stepperForm7.get(formControl).setValue(value);

    else if (formGroup == 'stepperForm8')
      this.stepperForm8.get(formControl).setValue(value);

    else if (formGroup == 'stepperForm12')
      this.stepperForm12.get(formControl).setValue(value);

    else if (formGroup == 'stepperForm13')
      this.stepperForm13.get(formControl).setValue(value);

    else if (formGroup == 'stepperForm14')
      this.stepperForm14.get(formControl).setValue(value);
  }

  timeChanged(value, formGroup, formControl) {
    // console.log(formControl);
    if (formGroup == 'stepperForm2')
      this.stepperForm2.get(formControl).setValue(value);

    else if (formGroup == 'stepperForm5')
      this.stepperForm5.get(formControl).setValue(value);

    else if (formGroup == 'stepperForm8')
      this.stepperForm8.get(formControl).setValue(value);

    else if (formGroup == 'stepperForm13')
      this.stepperForm13.get(formControl).setValue(value);
  }

  addSignature(formControl) {
    const dialogRef = this._utilityService.commonDialogBoxOpen(SignaturePadComponent,
      null, '100%', '100%', '100vw', '100vh').afterClosed().subscribe((data) => {
        console.log("data of sign", data);
        if (formControl == 'sign1') {
          this.sign1 = true
          this.stepperForm14.patchValue({
            sign1: data
          })
        }
        else {
          this.sign2 = true
          this.stepperForm14.patchValue({
            sign2: data
          });
        }
        console.log("sign value", this.stepperForm14.value);
      })
  }


  get multipleClientGroup() { return <FormArray>this.stepperForm14.get('clientDetails') }
  clientDetailsWithContact(data): Array<any> {
    console.log("injure function", data);

    if (data && data.length) {
      const client = []
      _.forEach(data, async (data) => {
        await client.push(new FormGroup({
          client: new FormControl(data.client),
          contact: new FormControl(data.contact),
        }))
      })
      console.log("person", client);
      return client;
    } else {
      return [this.formBuilder.group({
        client: new FormControl(''),
        contact: new FormControl(''),
      })
      ]
    }
  }

  addPerson() {
    const control = <FormArray>this.stepperForm14.controls.clientDetails
    control.push(this.formBuilder.group({
      client: new FormControl(),
      contact: new FormControl(),
    }))

  }

  deletePerson(data, i) {
    console.log("index value============", i);
    const control = <FormArray>this.stepperForm14.controls.clientDetails
    control.removeAt(i)
  }

  addFileModal() {
    let obj = {
      isIncident: true
    }
    this._utilityService.commonDialogBoxOpen(NewFileModalComponent,
      obj, '', '100%', '100vw', '100vh').afterClosed().subscribe((fileQueue) => {
        console.log("The queue recieved is", fileQueue);
        if (fileQueue == undefined || fileQueue.length == 0) return;

        _.forEach(fileQueue, (file) => {
          if (this.isEdit) {
            this.newFiles.push(file)
          } else {
            this.files.push(file);
          }
        })
        this._utilityService.handleSnackBar({ msg: "File uploaded successfully!", button: "OK" })
      }, err => {
        this._utilityService.handleSnackBar({ msg: "Something went wrong!", button: "OK" })
      });
  }



  deleteFile(event, index) {
    console.log("event if file removed", event, this.isEdit);
    this.files.splice(index, 1)
    console.log("after file removd", this.files);

  }
  deleteNewFile(event, index) {
    this.newFiles.splice(index, 1)
  }


  // API CALL

  onSubmit() {
    let param = {
    }
    this.loading = true;
    console.log("onSubmit is called");
    console.log("this.infoForm1.value", this.infoForm1.value);
    console.log("this.infoForm2.value", this.infoForm2.value);
    console.log("this.stepperForm1.value", this.stepperForm1.value)
    console.log("this.stepperForm2.value", this.stepperForm2.value);
    console.log("this.stepperForm3.value", this.stepperForm3.value);
    console.log("this.stepperForm5.value", this.stepperForm5.value);
    console.log("this.stepperForm6.value", this.stepperForm6.value);
    console.log("this.stepperForm7.value", this.stepperForm7.value);
    console.log("this.stepperForm8.value", this.stepperForm8.value);
    console.log("this.stepperForm9.value", this.stepperForm9.value);
    console.log("this.stepperForm10.value", this.stepperForm10.value);
    console.log("this.stepperForm11.value", this.stepperForm11.value);
    console.log("this.stepperForm12.value", this.stepperForm12.value);
    console.log("this.stepperForm13.value", this.stepperForm13.value);
    console.log("this.stepperForm14.value", this.stepperForm14.value);
    // this.loading = false;

    if (this.isEdit) {

      console.log("this is for edit form");


      let obj = {
        metaObj: {
          title: 'ioForm',
        },
        documentId: this.accidentId,
        userId: this.userId,
        onModel: 'accident',
        documentMetaId: this.extraDetails.documentMetaId,
        userDocumentId: this.extraDetails._id,
        files: this.files,
        newFiles: this.newFiles,
        details: {}
      }
      this.stepperForm2.value['location'] = {
        coords: { lat: this.latitude, lng: this.longitude },
        address: this.address
      }

      let details = {
        infoForm1: this.infoForm1.value,
        infoForm2: this.infoForm2.value,
        stepperForm1: this.stepperForm1.value,
        stepperForm2: this.stepperForm2.value,
        stepperForm3: this.stepperForm3.value,
        stepperForm5: this.stepperForm5.value,
        stepperForm6: this.stepperForm6.value,
        stepperForm7: this.stepperForm7.value,
        stepperForm8: this.stepperForm8.value,
        stepperForm9: this.stepperForm9.value,
        stepperForm10: this.stepperForm10.value,
        stepperForm11: this.stepperForm11.value,
        stepperForm12: this.stepperForm12.value,
        stepperForm13: this.stepperForm13.value,
        stepperForm14: this.stepperForm14.value
      }
      obj['details'] = details
      this.userDocumentService.updateUserDocument(obj).subscribe((response) => {
        console.log("response of new user document", response);
        this.loading = false
        this._utilityService.handleSnackBar({ msg: "Data updated successfully!", button: "OK" })
        this.redirect()
      }, error => {
        console.log("error while submit form", error);
        this._utilityService.handleSnackBar({ msg: error.msg, button: "OK" })
        this.loading = false
      })
    } else {
      let obj = {
        metaObj: {
          title: 'ioForm',
        },
        documentId: this.accidentId,
        userId: this.userId,
        onModel: 'accident',
        files: this.files,
        // documentId: this.planFormDetails._id,
        details: {}
      }
      this.stepperForm2.value['location'] = {
        coords: { lat: this.latitude, lng: this.longitude },
        address: this.address
      }

      let details = {
        infoForm1: this.infoForm1.value,
        infoForm2: this.infoForm2.value,
        stepperForm1: this.stepperForm1.value,
        stepperForm2: this.stepperForm2.value,
        stepperForm3: this.stepperForm3.value,
        stepperForm5: this.stepperForm5.value,
        stepperForm6: this.stepperForm6.value,
        stepperForm7: this.stepperForm7.value,
        stepperForm8: this.stepperForm8.value,
        stepperForm9: this.stepperForm9.value,
        stepperForm10: this.stepperForm10.value,
        stepperForm11: this.stepperForm11.value,
        stepperForm12: this.stepperForm12.value,
        stepperForm13: this.stepperForm13.value,
        stepperForm14: this.stepperForm14.value
      }
      obj['details'] = details

      this.userDocumentService.addUserDocument(obj).subscribe((response) => {
        console.log("response of new user document", response)
        this.loading = false
        // this._utilityService.handleSnackBar({ msg: "Witness form Submision successfully!", button: "OK" })
        this._utilityService.handleSnackBar({ msg: "Data added successfully!", button: "OK" })
        this.redirect()
      }, error => {
        console.log("error while submit form", error);
        this._utilityService.handleSnackBar({ msg: error.msg, button: "OK" })
        this.loading = false
      })

    }
    // this._utilityService.handleSnackBar({ msg: "Invastigation Reporting Form Submision Successfully!", button: "OK" })
  }

  redirect() {
    this._assetService.closeDisplayFile(true)
    let param = {
    }
    param['accidentId'] = this.accidentId
    if (this.isAdmin) {
      this.router.navigate(['/accident/single-accident'], { queryParams: param })
    }
    else {
      this.router.navigate(['/accident'])
    }
  }


}
